var exports = {
  "yF": "divider__-cxWqO",
  "fV": "topDivider__gz0HKr",
  "PJ": "footerText__5wcFox",
};

module.exports = exports;
